"use client";

import type { ReactNode } from "react";
import { ArrowRight } from "lucide-react";
import { useRouter } from "next/navigation";

import { Button } from "@/components/ui/button";
import { signIn, useSession } from "@/lib/auth/client";
import {
  trackGalleryCtaClicked,
  type GalleryCtaLocation,
} from "@/lib/posthog-client";

type GalleryStartButtonProps = {
  children?: ReactNode;
  trackLocation?: GalleryCtaLocation;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
};

export function GalleryStartButton({
  children = "Start Free Preview",
  trackLocation = "gallery",
  className,
  size = "lg",
}: GalleryStartButtonProps) {
  const router = useRouter();
  const { data: session } = useSession();

  function handleClick() {
    trackGalleryCtaClicked({ location: trackLocation });

    if (session?.user) {
      router.push("/app");
      return;
    }

    signIn.social({
      provider: "google",
      callbackURL: "/app",
    });
  }

  return (
    <Button
      size={size}
      onClick={handleClick}
      className={className ?? "bg-white text-black hover:bg-white/90"}
    >
      {children}
      <ArrowRight className="ml-2 h-4 w-4 shrink-0" />
    </Button>
  );
}
